var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwittericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm6.849,11.7q.01.221.01.445a9.729,9.729,0,0,1-9.8,9.8h0A9.745,9.745,0,0,1,6.785,20.39a7,7,0,0,0,.821.048,6.908,6.908,0,0,0,4.276-1.474,3.447,3.447,0,0,1-3.216-2.391,3.431,3.431,0,0,0,1.555-.059,3.444,3.444,0,0,1-2.762-3.375c0-.016,0-.03,0-.044a3.419,3.419,0,0,0,1.559.431,3.446,3.446,0,0,1-1.066-4.6,9.775,9.775,0,0,0,7.1,3.6,3.445,3.445,0,0,1,5.867-3.14A6.906,6.906,0,0,0,23.1,8.55a3.456,3.456,0,0,1-1.514,1.9,6.867,6.867,0,0,0,1.977-.542A7,7,0,0,1,21.849,11.7Zm0,0",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittericon);
export default __webpack_public_path__ + "static/media/twitter icon.169091e17b4c17d1ef912164579ee48d.svg";
export { ForwardRef as ReactComponent };